import { observer } from 'mobx-react-lite'

import { TdsIcon, TdsTooltip } from '@scania/tegel-react'
import { useTranslation } from 'react-i18next'
import { ButtonWrapper, IconWrapper } from './print-sorting-button.styles'

export interface SortingIconButtonProps {
  onClick: () => void
}

export const SortingIconButton = observer(function SortingIconButton({
  onClick
}: SortingIconButtonProps) {
  const { t } = useTranslation('common')

  return (
    <ButtonWrapper onClick={onClick}>
      <TdsTooltip
        placement='top'
        selector='#reverse'
        text={t('change-sorting')}
      />

      <IconWrapper id='reverse'>
        <TdsIcon name='sorting' size='lg' />
      </IconWrapper>
    </ButtonWrapper>
  )
})
